module.exports = __webpack_public_path__ + "img/overall.bc013dac.png";